import { useQuery } from '@tanstack/react-query';
import { getCachedInsights } from '../services/insights-service';

export function useInsights(userId: string | null) {
  return useQuery({
    queryKey: ['insights', userId],
    queryFn: () => getCachedInsights(userId!),
    enabled: !!userId,
  });
}
